module.exports = __webpack_public_path__ + "static/o_nama_2011-e1f1ce18d011e4ca98a987ab4fcf2a4a.png";